import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import { useClientCanceledSales } from '@/hooks/client';
import { ClientCanceledSalesModal } from '@/types/modal';
import { NoFooterModal } from '@/components/molecules/common/Modal';
import Table from '@/components/molecules/common/Table';
import { transformDateStringFrance } from '@/utilities/datetime';
import useTable from '@/hooks/table';

const defaultPageSize = 10;
const View: React.FC<{ modal: ClientCanceledSalesModal }> = ({ modal }) => {
  const { t } = useTranslation();

  const { client, onClose } = modal;

  const { page, pageSize, totalItems, onPageChange, persistTotalItems } = useTable(defaultPageSize);

  const { data: clientCanceledSales, isFetching } = useClientCanceledSales(
    Number(client.clientId),
    page,
    pageSize,
    true,
  );

  useEffect(() => {
    if (clientCanceledSales) persistTotalItems(clientCanceledSales.total || 0);
  }, [clientCanceledSales]);

  const columns: GridColDef[] = [
    { field: 'productId', headerName: t('modal.client_canceled_sales.item_id') },
    { field: 'date', headerName: t('modal.client_canceled_sales.date') },
  ];

  const rows = clientCanceledSales
    ? clientCanceledSales.data.map((item, index) => {
        const date = transformDateStringFrance(item.canceledDate);
        return { ...item, date: date || '', id: index };
      })
    : [];

  const body = (
    <Table
      rows={rows}
      columns={columns}
      loading={isFetching}
      table={{
        kind: 'DynamicTable',
        totalItem: totalItems,
        pageSize,
        pageSizeOptions: [5, defaultPageSize, 50],
        onPageChange,
      }}
      sx={{
        '& .MuiDataGrid-cell': {
          display: 'flex !important',
          padding: '0.6rem 1rem !important',
          alignItems: 'center !important',
        },
      }}
    />
  );

  return (
    <NoFooterModal
      title={t('modal.client_canceled_sales.title')}
      onClose={onClose}
      body={body}
      modalName="client_canceled_sales"
      containerStyle={{ width: 'calc(100% - 4rem)' }}
    />
  );
};

export default View;
